import React, { Component } from "react";
import {
    Form,
    Select,
} from "antd";

const { Option } = Select;

class SelectPaymentMethod extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    };

    render() {
        return (
            <Form.Item
                label={this.props.label}
                name={this.props.name}
                rules={[{ required: true, message: "Please select a method.", }]}
                initialValue={this.props.initialValue || ""}
            >
                <Select
                    placeholder="Select your Payment Type"
                    style={{ width: "100%" }}
                    onChange={this.props.onChange}
                    dropdownMatchSelectWidth={false}
                    allowClear
                >
                    <Option value="ach">ACH (2-3 business days)</Option>
                    <Option value="wire">Wire (0-1 business days, min $1,000)</Option>

                </Select>
            </Form.Item>
        );
    }
};

export default SelectPaymentMethod;